<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header pb-0">
            <p class="text-uppercase text-center">Enviar Layout de Pagos</p>
            <p class="text-uppercase text-sm mb-2 text-center">
              Modo de Conexión Actual
              <span class="badge bg-badge-teal ms-2" v-if="ambiente == 'DEV'">{{
                ambiente
              }}</span>
              <span class="badge bg-success ms-2" v-else>{{ ambiente }}</span>
            </p>
          </div>
          <hr class="horizontal dark" />
          <div class="card-body px-0 pt-0 pb-2">
            <div
              class="d-flex justify-content-center align-items-center py-4"
              v-if="isLoading"
            >
              Enviando Información
              <pulse-loader :loading="isLoading" :color="color" :size="size" />
            </div>

            <div v-else>
              <div class="card-header pb-0">
                <!-- INPUT FILE -->
                <div class="form-group">
                  <label>Seleccionar archivo (.xlsx)</label>
                  <input
                    type="file"
                    class="form-control"
                    accept=".xlsx"
                    @change="handleFile"
                  />
                </div>

                <!-- BOTÓN DESHABILITADO SI HAY ERRORES -->
                <button
                  class="btn btn-success"
                  @click="sendToBackend"
                  :disabled="cellErrors.length > 0 || !tableData.length"
                >
                  Enviar CFDI Pagos 2.0
                </button>

                <p v-if="errorMessage" style="color: red">
                  {{ errorMessage }}
                </p>

                <p v-if="cellErrors.length > 0" style="color: red">
                  Hay errores en el archivo. Corrige antes de enviar.
                  {{ cellErrors }}
                </p>
              </div>
              <!-- TABLA PREVIEW -->
              <div class="card-body px-0 pt-0 pb-2" v-if="tableData.length">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th v-for="(header, index) in headers" :key="index">
                          {{ header }}
                          <span v-if="!isValidHeader(header)" style="color: red"
                            >❌</span
                          >
                          <span v-else style="color: green">✔</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
                        <td
                          v-for="(header, colIndex) in headers"
                          :key="colIndex"
                        >
                          {{ row[header] }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import facturacion from "../../api/pagos";
import Swal from "sweetalert2";
import PulseLoader from "../../../node_modules/vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    PulseLoader,
  },
  created() {
    // Set an item in localStorage when the component is created
    this.getData();
  },
  data() {
    return {
      hrSistema: "",
      ambiente: "",
      tipo: "",
      color: "#535FA8",
      size: "45px",
      isLoading: false,
      headers: [],
      tableData: [],
      cellErrors: [],
      errorMessage: "",
      jsonCFDI: [],
      file: "",
      model: {
        token: "",
        cfdis: [],
      },
    };
  },

  methods: {
    getData() {
      this.ambiente = localStorage.getItem("mode");
      this.tipo = localStorage.getItem("tipo");
    },
    /* ===============================
       VALIDAR HEADERS REQUERIDOS
    =============================== */
    isValidHeader(header) {
      const required = [
        "ID_PAGO", // nuevo
        "FECHA_EMISION",
        "SERIE",
        "FOLIO",
        "LUGAR_EXPEDICION",
        //"EXPORTACION", = 01
        "EMISOR_RFC",
        "EMISOR_RAZON_SOCIAL",
        //"EMISOR_USO_CFDI", = G03
        "EMISOR_REGIMEN_FISCAL",
        "RECEPTOR_RFC",
        "RECEPTOR_RAZON_SOCIAL",
        // "RECEPTOR_USO_CFDI", CP01
        "RECEPTOR_REGIMEN",
        "RECEPTOR_CP",
        // "CONCEPTOS_CANTIDAD", 1
        // "CONCEPTOS_SUBTOTAL", 1
        //"CONCEPTO_IMPORTE", 0
        // "CONCPTOS_NUM_ID", SERV0001
        //"CONCEPTOS_OBJ", 01
        "TOTAL_RET_IVA",
        "TOTAL_RET_ISR",
        "TOTAL_RET_IEPS",
        "TOTAL_TRAS_BIVA16",
        "TOTAL_TRAS_IIVA16",
        "TOTAL_TRAS_BIVA8",
        "TOTAL_TRAS_IIVA8",
        "TOTAL_TRAS_BIVA0",
        "TOTAL_TRAS_IIVA0",
        "TOTAL_TRAS_BIVAEX",
        "MONTO_TOTAL_PAGOS",
        "PAGO_FECHA",
        "PAGO_FORMA_PAGO",
        "PAGO_MONEDA",
        "PAGO_MONTO", //nuevo
        "PAGO_TIPO_CAMBIO",
        "PAGO_NUM_OP",
        "PAGO_TIPO_CAD_PAGO",
        "PAGO_CERT_PAGO",
        "PAGO_CAD_PAG",
        "PAGO_SELLO",
        "DOCREL_ID",
        "DOCREL_SERIE",
        "DOCREL_FOLIO",
        "DOCREL_MONEDA",
        "DOCREL_EQUIVALENCIA",
        "DOCREL_PARCIALIDAD",
        "DOCREL_IMPORTE_SALDO_ANT",
        "DOCREL_IMP_PAGADO",
        "DOCREL_SALDO_INS",
        "DOCREL_OBJ",
        "DOREL_IR_BASE_DR",
        "DOREL_IR_IMPUESTO_DR",
        "DOREL_IR_TIPO_FACTOR_DR",
        "DOREL_IR_TASA_DR",
        "DOREL_IR_IMPORTE_DR",
        "DOREL_IT_BASE_DR",
        "DOREL_IT_IMPUESTO_DR",
        "DOREL_IT_TIPO_FACTOR_DR",
        "DOREL_IT_TASA_DR",
        "DOREL_IT_IMPORTE_DR",
        "IMPUESTOSP_R_IMPUESTO",
        "IMPUESTOSP_R_IMPORTE",
        "IMPUESTOSP_T_BASEP",
        "IMPUESTOSP_T_IMPUESTOP",
        "IMPUESTOSP_T_TIPOFACTORP",
        "IMPUESTOSP_T_TASAP",
        "IMPUESTOSP_T_IMPORTEP",
      ];
      if (required.includes(header)) {
        return required.includes(header);
      } else {
        if (!this.cellErrors.includes(header)) {
          this.cellErrors.push(header);
        }
      }
    },

    /* ===============================
       LEER ARCHIVO
    =============================== */
    handleFile(e) {
      this.cellErrors = [];
      this.errorMessage = "";

      this.file = e.target.files[0];
      const reader = new FileReader();

      reader.onload = (evt) => {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        this.headers = Object.keys(json[0] || {});
        this.tableData = json;

        this.validateRows();
      };

      reader.readAsArrayBuffer(this.file);
    },

    /* ===============================
       VALIDACIONES
    =============================== */
    validateRows() {
      this.tableData.forEach((row, index) => {
        // Validar UUID v4
        const uuidRegex =
          /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

        if (!uuidRegex.test(row.DOCREL_ID)) {
          this.cellErrors.push(`Fila ${index + 1}: UUID inválido`);
        }

        if (!row.MONTO_TOTAL_PAGOS) {
          this.cellErrors.push(
            `Fila ${index + 1}: MONTO_TOTAL_PAGOS obligatorio`,
          );
        }
      });
    },

    /* ===============================
       CONSTRUIR JSON CFDI
    =============================== */
    /* ===============================
   CONSTRUIR JSON CFDI AGRUPADO
=============================== */
    buildJSON() {
      const formatSAT = (value) => {
        return Number(value || 0).toFixed(6);
      };

      const buildTraslado = (
        base,
        impuesto,
        tipoFactor,
        tasa,
        importe,
        tipo,
      ) => {
        if (!base || Number(base) <= 0) return null;

        let traslado = {
          [`base_${tipo}`]: Number(base),
          [`impuesto_${tipo}`]: impuesto,
          [`tipo_factor_${tipo}`]: tipoFactor,
        };

        if (tipoFactor !== "Exento") {
          traslado[`tasa_o_cuota_${tipo}`] = Number(formatSAT(tasa));
          traslado[`importe_${tipo}`] = Number(importe);
        }

        return traslado;
      };

      /* ===============================
     AGRUPAR POR ID_PAGO
  =============================== */
      const grouped = {};

      this.tableData.forEach((row) => {
        const key = `${row.ID_PAGO}_${row.DOCREL_ID}`;

        if (!grouped[key]) {
          grouped[key] = [];
        }

        grouped[key].push(row);
      });

      /* ===============================
     CONSTRUIR JSON FINAL
  =============================== */
      this.jsonCFDI = Object.values(grouped).map((rows) => {
        const first = rows[0];

        let pagos = [];
        let totales = {
          monto_total_pagos: 0,
        };

        rows.forEach((row) => {
          /* ==============================
         TRASLADOS DR
      ============================== */
          let trasladoDR = buildTraslado(
            row.DOREL_IT_BASE_DR,
            row.DOREL_IT_IMPUESTO_DR,
            row.DOREL_IT_TIPO_FACTOR_DR,
            row.DOREL_IT_TASA_DR,
            row.DOREL_IT_IMPORTE_DR,
            "dr",
          );

          let trasladosDR = trasladoDR ? [trasladoDR] : [];

          /* ==============================
         RETENCIONES DR
      ============================== */
          let retencionesDR = [];

          if (Number(row.DOREL_IR_BASE_DR) > 0) {
            retencionesDR.push({
              base_dr: Number(row.DOREL_IR_BASE_DR),
              impuesto_dr: row.DOREL_IR_IMPUESTO_DR,
              tipo_factor_dr: row.DOREL_IR_TIPO_FACTOR_DR,
              tasa_o_cuota_dr: Number(formatSAT(row.DOREL_IR_TASA_DR)),
              importe_dr: Number(row.DOREL_IR_IMPORTE_DR),
            });
          }

          /* ==============================
         TRASLADOS P
      ============================== */
          let trasladoP = buildTraslado(
            row.IMPUESTOSP_T_BASEP,
            row.IMPUESTOSP_T_IMPUESTOP,
            row.IMPUESTOSP_T_TIPOFACTORP,
            row.IMPUESTOSP_T_TASAP,
            row.IMPUESTOSP_T_IMPORTEP,
            "p",
          );

          let trasladosP = trasladoP ? [trasladoP] : [];

          /* ==============================
         ACUMULAR TOTALES
      ============================== */
          totales.monto_total_pagos += Number(row.PAGO_MONTO);

          if (trasladoP) {
            if (trasladoP.tipo_factor_p === "Exento") {
              totales.total_traslados_base_iva_exento =
                (totales.total_traslados_base_iva_exento || 0) +
                trasladoP.base_p;
            }

            if (
              trasladoP.tipo_factor_p === "Tasa" &&
              Number(trasladoP.tasa_o_cuota_p) === 0.16
            ) {
              totales.total_traslados_base_iva16 =
                (totales.total_traslados_base_iva16 || 0) + trasladoP.base_p;

              totales.total_traslados_impuesto_iva16 =
                (totales.total_traslados_impuesto_iva16 || 0) +
                trasladoP.importe_p;
            }

            if (
              trasladoP.tipo_factor_p === "Tasa" &&
              Number(trasladoP.tasa_o_cuota_p) === 0
            ) {
              totales.total_traslados_base_iva0 =
                (totales.total_traslados_base_iva0 || 0) + trasladoP.base_p;
            }
          }

          /* ==============================
         ARMAR PAGO
      ============================== */
          pagos.push({
            fecha_pago: row.PAGO_FECHA + "T" + this.hrSistema,
            forma_de_pago_p: row.PAGO_FORMA_PAGO,
            moneda_p: row.PAGO_MONEDA,
            tipo_cambio_p: Number(row.PAGO_TIPO_CAMBIO || 1),
            monto: Number(row.PAGO_MONTO),
            num_operacion: row.PAGO_NUM_OP,

            docto_relacionado: [
              {
                id_documento: row.DOCREL_ID,
                serie: row.DOCREL_SERIE,
                folio: row.DOCREL_FOLIO,
                moneda_dr: row.DOCREL_MONEDA,
                equivalencia_dr: Number(row.DOCREL_EQUIVALENCIA || 1),
                num_parcialidad: Number(row.DOCREL_PARCIALIDAD),
                imp_saldo_ant: Number(row.DOCREL_IMPORTE_SALDO_ANT),
                imp_pagado: Number(row.DOCREL_IMP_PAGADO),
                imp_saldo_insoluto: Number(row.DOCREL_SALDO_INS),
                objeto_imp_dr: row.DOCREL_OBJ,

                ...(trasladosDR.length || retencionesDR.length
                  ? {
                      impuestos_dr: {
                        ...(trasladosDR.length && {
                          traslados_dr: trasladosDR,
                        }),
                        ...(retencionesDR.length && {
                          retenciones_dr: retencionesDR,
                        }),
                      },
                    }
                  : {}),
              },
            ],

            ...(trasladosP.length
              ? { impuestos_p: { traslados_p: trasladosP } }
              : {}),
          });
        });

        /* ==============================
       JSON FINAL POR ID_PAGO
    ============================== */
        return {
          fecha_emision: first.FECHA_EMISION + " " + this.hrSistema,
          serie: first.SERIE,
          folio: Number(first.FOLIO),

          tipo_comprobante: "P",
          moneda: "XXX",
          subtotal: 0,
          total: 0,
          lugar_expedicion: first.LUGAR_EXPEDICION,
          exportacion: "01",

          emisor: {
            rfc: first.EMISOR_RFC,
            razon_social: first.EMISOR_RAZON_SOCIAL,
            regimen_fiscal: first.EMISOR_REGIMEN_FISCAL,
          },

          receptor: {
            rfc: first.RECEPTOR_RFC,
            razon_social: first.RECEPTOR_RAZON_SOCIAL,
            uso_cfdi: "CP01",
            regimen_fiscal: first.RECEPTOR_REGIMEN,
            codigo_postal: first.RECEPTOR_CP,
          },

          conceptos: [
            {
              clave_prod_serv: "84111506",
              descripcion: "Pago",
              clave_unidad: "ACT",
              cantidad: 1,
              valor_unitario: 0,
              importe: 0,
              subtotal: 0,
              descuento: 0,
              objeto_impuesto: "01",
            },
          ],

          complementos: {
            pagos_20: {
              version: "2.0",
              totales,
              pago: pagos,
            },
          },
        };
      });
    },

    /* ===============================
       ENVIAR AL BACKEND
    =============================== */
    sendToBackend() {
      this.isLoading = true;
      this.hrSistema = this.obtenerHoraSistema();
      this.buildJSON();
      this.model.token = localStorage.getItem("token");
      this.model.cfdis = this.jsonCFDI;
      facturacion
        .sendData(this.model)
        .then((result) => {
          Swal.fire({
            title: "Peticiones Enviadas",
            text: result.data.status,
            icon: "success",
            confirmButtonColor: "success",
            confirmButtonText: "Continuar",
          });
          (this.headers = []),
            (this.tableData = []),
            (this.cellErrors = []),
            (this.errorMessage = ""),
            (this.jsonCFDI = []);
          this.file = [];
          this.isLoading = false;
        })
        .catch((err) => {
          Swal.fire({
            title: "Error al  Enviar Datos",
            text: err,
            icon: "error",
            confirmButtonColor: "error",
            confirmButtonText: "Continuar",
          });
          this.isLoading = false;
        });
    },
    obtenerHoraSistema() {
      const fecha = new Date();
      const hours = String(fecha.getHours()).padStart(2, "0");
      const minutes = String(fecha.getMinutes()).padStart(2, "0");
      const seconds = String(fecha.getSeconds()).padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>
<style scoped>
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #535fa8; /* The color of the spinning part */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite; /* CSS animation for spinning */
  margin: 20px auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<style lang="scss">
$teal: #28a745;

.check-verde {
  accent-color: $teal;
}
.bg-badge-teal {
  background-color: #20c997;
  color: white;
}
</style>
